import { createWebHistory } from 'vue-router'
import createRouter from '@/views/routes'

export default createRouter(createWebHistory())